export default "__VITE_ASSET__rCuYkdPt__"